import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const imageCarouselStyle = {
  wrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    display: "inline-block",
    maxWidth: 540,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      minHeight: 630,
    },
  }),
  button: (theme: Theme): SystemStyleObject<Theme> => ({
    [theme.breakpoints.down("lg")]: {
      justifyContent: "center",
    },
  }),
};

export default imageCarouselStyle;
